import { gsap, ScrollTrigger } from "./globals.js";
import { isLargeNonTouchDevice } from './globals.js';

if (isLargeNonTouchDevice()) {
    let activeCursor = null;  // Track the currently active cursor
    function initCustomCursor(sectionOrSelector, cursorSelector) {
        const section = (typeof sectionOrSelector === 'string')
            ? document.querySelector(sectionOrSelector)
            : sectionOrSelector;

        if (!section) return;

        const cursor = section.querySelector(cursorSelector);
        if (!cursor) return;

        gsap.set(cursor, { position: "absolute", opacity: 0, scale: 0.4 });

        let isHovered = false;
        let leaveTimeout;

        section.addEventListener("mouseenter", (e) => {
            isHovered = true;

            clearTimeout(leaveTimeout); // prevent any pending hide

            // Hide all other cursors
            document.querySelectorAll('.cursor').forEach((el) => {
                if (el !== cursor) {
                    gsap.to(el, {
                        scale: 0.4,
                        opacity: 0,
                        ease: "expo.out",
                        duration: 0.8
                    });
                }
            });

            const bounds = section.getBoundingClientRect();
            const top = ((e.clientY - bounds.top) / bounds.height) * 100;
            const left = ((e.clientX - bounds.left) / bounds.width) * 100;

            gsap.set(cursor, {
                top: `${top}%`,
                left: `${left}%`
            });

            gsap.to(cursor, {
                scale: 1,
                opacity: 1,
                ease: "expo.out",
                duration: 0.6
            });

            activeCursor = cursor;
        });

        section.addEventListener("mouseleave", () => {
            isHovered = false;

            leaveTimeout = setTimeout(() => {
                if (!isHovered) {
                    gsap.to(cursor, {
                        scale: 0.4,
                        opacity: 0,
                        ease: "expo.out",
                        duration: 0.8
                    });

                    if (activeCursor === cursor) {
                        activeCursor = null;
                    }
                }
            }, 50); // short delay to avoid re-showing glitches
        });

        section.addEventListener("mousemove", (e) => {
            if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
                const bounds = section.getBoundingClientRect();
                const top = e.clientY - bounds.top;
                const left = e.clientX - bounds.left;

                gsap.to(cursor, {
                    top: `${top}px`,
                    left: `${left}px`,
                    ease: "power3.out",
                    duration: 0.7
                });
            }
        });
    }


    // HP SPLASH VIDEO CURSOR
    const hpSplashVideo = document.querySelector(".hp-splash__video-wrapper");
    if (hpSplashVideo) {
        initCustomCursor(".hp-splash__video-wrapper", ".cursor--video");
    }

    // FOOTER CURSOR CALLBACK
    const footerCTA = document.querySelector(".footer-cta");
    if (footerCTA) {
        initCustomCursor(".footer-cta", ".cursor--cta");
    }

    // IMAGE ENLARGE CURSOR CALLBACK
    document.querySelectorAll(".image-enlarge").forEach((image) => {
        const cursor = document.createElement("div");
        cursor.classList.add("cursor", "cursor--enlarge", "cursor--sm"); // Add both classes

        const cursorLabel = document.createElement("div");
        cursorLabel.classList.add("cursor__label");
        cursorLabel.innerHTML = "Zoom in"; // Add the text

        cursor.appendChild(cursorLabel);

        image.appendChild(cursor);  // Append the cursor inside the .image-enlarge element

        initCustomCursor(image, ".cursor");  // Pass the image element itself to initCustomCursor
    });

    // DRAG CURSOR FOR SLIDERS
    const dragCursorTargets = [
      document.querySelector('.gallery__slider'),
      ...document.querySelectorAll('.image-text-slider__slider')
    ];

    dragCursorTargets.forEach(slider => {
      if (slider) {
        initCustomCursor(slider, '.cursor--drag');
      }
    });
}
